import { Link, Text } from "@gravity-ui/uikit";
import { ILink } from "src/types";
import css from "src/widgets/Footer/Footer.module.scss";

export const FooterLink = ({ item }: { item: ILink }) => {
  return (
    <Text variant="body-2" as="div">
      <Link className={css.navigateLink} href={item.path} view="primary">
        {item.name}
      </Link>
    </Text>
  );
};
